import {
  Component,
  Input,
  Output,
  EventEmitter,
  OnInit,
  AfterViewInit,
  OnDestroy,
} from '@angular/core';
import { Observable } from 'rxjs/Observable';
import { Subject } from 'rxjs/Subject';
import { GridOptions } from 'ag-grid';

import { MarketDetail, Metrics } from '~/core/model';

import { SIZES } from '~/shared/configs';
import { COLUMN_TYPE } from '~shared/components/grids';
import { NumericPipe } from '~shared/pipes';
import { MarketTableRowComponent } from './market-table-row.component';
import { GridHeaderComponent } from '~shared/components/assorted/grid-header.component';

@Component({
  selector: 'idap-market-table',
  templateUrl: './market-table.component.html',
  host: {
    class: 'full-width full-height'
  },
  styleUrls: ['./market-table.component.scss'],
  entryComponents: [MarketTableRowComponent]
})
export class MarketTableComponent implements OnInit, AfterViewInit, OnDestroy {

  @Input() private markets: Observable<MarketDetail[]>;
  @Output() public onMarketSelected: EventEmitter<MarketDetail> = new EventEmitter();

  private renderCurrencyValue = function(params) {
    return `<span class="text-center">${!params.data.metricdata ? '-' : new NumericPipe().transform(params.value, COLUMN_TYPE.CURRENCY)}</span>`;
  }

  private renderRPSFCurrencyValue = function(params) {
    return `<span class="text-center">${!params.data.metricdata ? '-' : new NumericPipe().transform(params.value, COLUMN_TYPE.CURRENCY, 3)}</span>`;
  }

  private renderNumberValue = function(params) {
    return `<span class="text-center">${!params.data.metricdata ? '-' : new NumericPipe().transform(params.value, 'commaSeparated')}</span>`;
  }

  private renderPercentageValue = function(params) {
    return `<span class="text-center">${!params.data.metricdata ? '-' : new NumericPipe().transform(params.value, COLUMN_TYPE.PERCENTAGE, 1)}</span>`;
  }

  options: GridOptions = {
    rowHeight: SIZES.characterHeight(3),
    headerHeight: SIZES.characterHeight(3),
    rowClass: 'table-row-flex',
    rowSelection: 'single',
    getRowNodeId: (data) => data.id,
    columnDefs: [
      { colId: 'name', headerName: 'Name', field: 'name', tooltipField: 'name', width: SIZES.characterWidth(28.6), headerClass: 'align-left', cellClass: 'table-cell-ellipsis', headerComponentFramework: <{ new(): GridHeaderComponent }>GridHeaderComponent },
      { colId: 'occupancy', headerName: 'Occupancy', field: 'metrics.occupancy', width: SIZES.characterWidth(11), cellRenderer: this.renderPercentageValue.bind(this), cellClass: 'table-cell-center', headerComponentFramework: <{ new(): GridHeaderComponent }>GridHeaderComponent },
      { colId: 'effectiveRent', headerName: 'Effective Rent', field: 'metrics.effectiveRent', width: SIZES.characterWidth(9), cellRenderer: this.renderCurrencyValue.bind(this), cellClass: 'table-cell-center', headerComponentFramework: <{ new(): GridHeaderComponent }>GridHeaderComponent },
      { colId: 'effectiveRentPerSquareFoot', headerName: 'Effective RPSF', field: 'metrics.effectiveRPSF', width: SIZES.characterWidth(9), cellRenderer: this.renderRPSFCurrencyValue.bind(this), cellClass: 'table-cell-center', headerComponentFramework: <{ new(): GridHeaderComponent }>GridHeaderComponent },
      { colId: 'annualRentChange', headerName: 'Annual Rent Change', field: 'metrics.annualRentChange', width: SIZES.characterWidth(11.2), cellRenderer: this.renderPercentageValue.bind(this), cellClass: 'table-cell-center', headerComponentFramework: <{ new(): GridHeaderComponent }>GridHeaderComponent },
      { colId: 'askingRent', headerName: 'Asking Rent', field: 'metrics.askingRent', width: SIZES.characterWidth(12), cellRenderer: this.renderCurrencyValue.bind(this), cellClass: 'table-cell-center', headerComponentFramework: <{ new(): GridHeaderComponent }>GridHeaderComponent },
      { colId: 'concessions', headerName: 'Concessions', field: 'metrics.concessions', width: SIZES.characterWidth(13.5), cellRenderer: this.renderPercentageValue.bind(this), cellClass: 'table-cell-center', headerComponentFramework: <{ new(): GridHeaderComponent }>GridHeaderComponent },
      { colId: 'supply', headerName: 'Supply', field: 'metrics.supply', width: SIZES.characterWidth(8), cellRenderer: this.renderNumberValue.bind(this), cellClass: 'table-cell-center', headerComponentFramework: <{ new(): GridHeaderComponent }>GridHeaderComponent },
      { colId: 'absorption', headerName: 'Absorption', field: 'metrics.absorption', width: SIZES.characterWidth(12.5), cellRenderer: this.renderNumberValue.bind(this), cellClass: 'table-cell-center', headerComponentFramework: <{ new(): GridHeaderComponent }>GridHeaderComponent },
      { colId: 'unitCount', headerName: 'Existing Units', field: 'metrics.unitCount', width: SIZES.characterWidth(12.5), cellRenderer: this.renderNumberValue.bind(this), cellClass: 'table-cell-center', headerComponentFramework: <{ new(): GridHeaderComponent }>GridHeaderComponent }
    ],
  };

  public onDestroy: Subject<MarketTableComponent> = new Subject();

  overlayLoadingTemplate;

  constructor() {
    this.overlayLoadingTemplate = '<div class="raul-content-loader-wrapper">' +
    '<div class="raul-content-loader"></div>'+
    '</div>';
  }

  ngOnInit() { }

  ngAfterViewInit() {
    this.markets
      .takeUntil(this.onDestroy)
      .subscribe(data => this.options.api.setRowData(data));
  }

  onCellClicked(e) {
    this.onMarketSelected.next(e.node.data);
  }

  selectRow(id: any): void {
    const row = this.options.api.getRowNode(id);
    if (row) {
      row.setSelected(true);
      this.options.api.ensureIndexVisible(row.rowIndex);
    }
  }

  ngOnDestroy() {
    this.onDestroy.next(this);
    this.onDestroy.complete();

    this.onMarketSelected.complete();
  }
}




// WEBPACK FOOTER //
// ./src/app/features/market/components/tables/market-table.component.ts